import { render, staticRenderFns } from "./bankruptcyManagerCheck.vue?vue&type=template&id=ec9040d6&scoped=true&"
import script from "./bankruptcyManagerCheck.vue?vue&type=script&lang=js&"
export * from "./bankruptcyManagerCheck.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcyManagerCheck.vue?vue&type=style&index=0&id=ec9040d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9040d6",
  null
  
)

export default component.exports